import React from 'react';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';
import {
  DAY_ORDER,
  cellVisual,
  dayTotal,
  fmtHour,
  windowsFor,
} from './helpers';

import type { IDayLabel, LimitsMap } from './helpers';

interface IProps {
  limits: LimitsMap;
  dayLabels: IDayLabel[];
}

const WindowsView: React.FC<IProps> = ({ limits, dayLabels }) => {
  const { t } = useTranslation();

  return (
    <div className={s.card}>
      {DAY_ORDER.map((day) => {
        const windows = windowsFor(limits[day] ?? {});
        const capacity = dayTotal(limits, day);
        const noun =
          windows.length === 1
            ? t('queueLimits.window')
            : t('queueLimits.windowsPlural');
        return (
          <div key={day}>
            <div className={s.windowDayHeader}>
              <span className={s.windowDayName}>{dayLabels[day].full}</span>
              <span className={s.windowMeta}>
                {t('queueLimits.windowsMeta', {
                  count: windows.length,
                  noun,
                  capacity: capacity.toLocaleString(),
                })}
              </span>
            </div>

            {windows.length > 0 ? (
              <div>
                <div className={s.windowColsHeader}>
                  <span>{t('labels.from')}</span>
                  <span>{t('labels.to')}</span>
                  <span>{t('labels.limit')}</span>
                </div>
                {windows.map((w) => {
                  const visual = cellVisual(w.value);
                  return (
                    <div className={s.windowRow} key={`${w.from}-${w.to}`}>
                      <span className={s.windowFrom}>
                        <span className={s.windowDot} />
                        {fmtHour(w.from)}
                      </span>
                      <span className={s.windowTo}>{fmtHour(w.to)}</span>
                      <span className={s.windowValue}>
                        <span
                          className={s.windowSwatch}
                          style={{ background: visual.bg }}
                        />
                        {w.value === 0
                          ? t('queueLimits.paused')
                          : t('queueLimits.patientsValue', { count: w.value })}
                      </span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className={s.windowEmpty}>{t('queueLimits.emptyDay')}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default WindowsView;
